import {
  TradersLoaded,
  TraderAdded,
  TraderConfigurationLoaded,
  TraderUpdated,
  TraderDeleted
} from "./traders.actions";
import { Trader } from "./trader";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import TraderConfiguration from "./traderConfiguration";
import * as _ from "lodash";

export class TradersReducer extends ReducerBase<Trader[]> {
  constructor() {
    super();
    this.addHandler(TradersLoaded.EventName, this.handleTradersLoaded);
    this.addHandler(TraderAdded.EventName, this.handleTraderAdded);
    this.addHandler(TraderUpdated.EventName, this.handleTraderUpdated);
    this.addHandler(TraderDeleted.EventName, this.handleTraderDeleted)
  }

  handleTradersLoaded(
    state: Trader[] = initialState.traders,
    event: TradersLoaded
  ): Trader[] {
    return event.traders;
  }

  handleTraderAdded(
    state: Trader[] = initialState.traders,
    event: TraderAdded
  ): Trader[] {
    return _.sortBy([...state, { ...event.trader }], [t => t.lastName?.toLowerCase(), t => t.firstName?.toLowerCase()]); 
  }

  handleTraderUpdated(
    state: Trader[] = initialState.traders,
    event: TraderUpdated
  ): Trader[] {
    return  _.sortBy(state.map(t => (t.userId === event.trader.userId ? event.trader : t)), [t => t.lastName?.toLowerCase(), t => t.firstName?.toLowerCase()]); 
  }

  handleTraderDeleted(
    state: Trader[] = initialState.traders,
    event: TraderDeleted
  ): Trader[] {
    return state.filter(t => (t.userId !== event.trader.userId));
  }

  handleDefault(state: Trader[] = initialState.traders) {
    return state;
  }
}

export class TraderConfigurationReducer extends ReducerBase<
  TraderConfiguration
  > {
  constructor() {
    super();
    this.addHandler(
      TraderConfigurationLoaded.EventName,
      this.handleConfigurationLoaded
    );
  }

  handleConfigurationLoaded(
    state: TraderConfiguration = initialState.traderConfiguration,
    event: TraderConfigurationLoaded
  ): TraderConfiguration {
    return event.configuration;
  }

  handleDefault(state: TraderConfiguration = initialState.traderConfiguration) {
    return state;
  }
}